import { apiClient } from './api';

/** 서버 `DriveFolderView`(project-files.service.ts)와 같다 */
export interface DriveFolderView {
  linked: boolean;
  folderId: string | null;
  url: string | null;
  path: string[];
  folders: { kind: string; name: string; from: string; id: string | null; url: string | null }[];
  others: { name: string; id: string; url: string }[];
}

/** 프로젝트 드라이브 폴더 — 사이트가 만들고, 목록은 드라이브에서 바로 읽는다 */
export const driveApi = {
  get: (projectId: number): Promise<DriveFolderView> => apiClient.get(`/projects/${projectId}/files/drive`),
  ensure: (projectId: number): Promise<DriveFolderView> => apiClient.post(`/projects/${projectId}/files/drive`),
  addFolder: (projectId: number, name: string): Promise<DriveFolderView> => apiClient.post(`/projects/${projectId}/files/drive/folders`, { name }),
};
